/**
 * Build ordered unique clause-locate hints for Word paragraph search.
 * After approve/reopen, live text often matches approved/AI — not client.
 */

const normalizeWs = (s: string): string => s.replace(/\s+/g, " ").trim();

/** Minimum normalized length for a hint to be useful in body search. */
export const MIN_CLAUSE_HINT_LEN = 12;

export const collectClauseTextHints = (
  ...candidates: Array<string | null | undefined>
): string[] => {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of candidates) {
    const trimmed = (raw ?? "").trim();
    if (!trimmed) {
      continue;
    }
    const key = normalizeWs(trimmed).toLowerCase();
    if (key.length < MIN_CLAUSE_HINT_LEN || seen.has(key)) {
      continue;
    }
    seen.add(key);
    out.push(trimmed);
  }
  return out;
};

export type SuggestionLocateTexts = {
  readonly approved_text?: string | null;
  readonly ai_suggested_text?: string | null;
  readonly client_suggested_text?: string | null;
  readonly original_text?: string | null;
};

/**
 * Preferred order for locate after approve / reopen / restore:
 * approved → AI → client → original.
 */
export const clauseLocateHintsFromSuggestion = (
  s: SuggestionLocateTexts,
): string[] =>
  collectClauseTextHints(
    s.approved_text,
    s.ai_suggested_text,
    s.client_suggested_text,
    s.original_text,
  );
